import createHistory from "history/createBrowserHistory";
import { message } from "antd";

//session 만료로 인한 재 로그인
export function processAnExpiredSession() {
  sessionStorage.clear();

  window.alert("Session expired. Please login again.🙏");
  const history = createHistory();
  history.push("/login");
  history.go();
}

export function processAnFetchData(err) {
  if (err.code === 209) {
    processAnExpiredSession();
  } else {
    const errorMessage = err.message ? err.message : "Sorry, There was an error while loading data. Please try again.🙏";
    message.error(errorMessage);
  }
}
